<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
	<path class="color-solid" d="M12,6c4.41,0,8,2.69,8,6s-3.59,6-8,6s-8-2.69-8-6S7.59,6,12,6 M12,4C6.48,4,2,7.58,2,12s4.48,8,10,8s10-3.58,10-8S17.52,4,12,4L12,4z" />
	<ellipse class="color-vector" cx="12" cy="12" rx="6.5" ry="4.5" />
</svg>
</template>